<div class="overview-container">
    <!-- regular user under enterprise with custom home page  -->
    <!--    <div *ngIf="!user?.dashboard && isLoaded && embedCustomHomePage" [@staggerAnimation] style="width: 100%; height: 100%">-->
    <!--        <iframe [src]="embedCustomHomePage | pipeSafe:'resourceUrl'" width="100%" height="100%">-->
    <!--            Sorry your browser does not support inline frames. please use latest Chrome browser.-->
    <!--        </iframe>-->
    <!--    </div>-->
    <!-- regular user or user under enterprise without a custom home page  -->
    <!--    <div *ngIf="!user?.dashboard && isLoaded && !embedCustomHomePage">-->
    @if (!user?.dashboard && isLoaded) {
        <div>
            <div class="user-overview" [@staggerAnimation]>
                @if (isLoaded) {
                    <div [style.grid-area]="'chart1'">
                        <app-overview-card [type]="5" title="{{'general.networkState' | transloco}}">
                            <app-server-avg class="svrChart"></app-server-avg>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart2'">
                        <app-overview-card [type]="5" title="{{'general.studioActivity' | transloco}}">
                            <app-usage-avg class="svrChart"></app-usage-avg>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart3'">
                        <app-overview-card [type]="5" title="{{'general.storageUsed' | transloco}}">
                            <app-resource-avg [resources]="resources" class="svrChart"></app-resource-avg>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart4'">
                        <app-overview-card [type]="5" title="{{'general.resourceDistributionVideo' | transloco}}">
                            <ngx-charts-pie-grid
                                    [scheme]="colorScheme"
                                    [results]="dataResourceByVideo"
                                    [label]="'count'"
                                    [minWidth]="100"
                                    (select)="onSelect($event)">
                            </ngx-charts-pie-grid>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart5'">
                        <app-overview-card [type]="5" title="{{'general.resourceDistributionImage' | transloco}}">
                            <ngx-charts-pie-grid
                                    [scheme]="colorScheme"
                                    [results]="dataResourceByImage"
                                    [label]="'count'"
                                    [minWidth]="100"
                                    (select)="onSelect($event)">
                            </ngx-charts-pie-grid>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart8'">
                        <app-overview-card [type]="5" title="{{'general.playerSocket' | transloco}}">
                            <ngx-charts-advanced-pie-chart
                                    [scheme]="colorScheme"
                                    [label]="'remote player'"
                                    [results]="dataRemoteScreens"
                                    (select)="onSelect($event)">
                            </ngx-charts-advanced-pie-chart>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart9'">
                        <app-overview-card [type]="4" [val1]="user" [val2]="appData"></app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart10'">
                        <app-overview-card [type]="3" [val1]=""></app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart11'">
                        <app-overview-card [type]="5" title="{{'general.liveLog' | transloco}}">
                            <app-overview-log></app-overview-log>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'chart14'">
                        <app-overview-card [type]="5" title="{{'general.moduleDistribution' | transloco}}">
                            <ngx-charts-bar-vertical
                                    [scheme]="colorScheme"
                                    [showXAxisLabel]="false"
                                    [showYAxisLabel]="false"
                                    [xAxis]="false"
                                    [yAxis]="true"
                                    [legend]="true"
                                    [barPadding]="24"
                                    [showDataLabel]="true"
                                    [roundEdges]="false"
                                    [results]="dataUsageTotal"
                                    (select)="onSelect($event)">
                            </ngx-charts-bar-vertical>
                        </app-overview-card>
                    </div>
                }
                <div [style.grid-area]="'chart15'">
                    <app-overview-card [type]="5" title="{{'general.networkCPU' | transloco}}">
                        <app-overview-network-cpu></app-overview-network-cpu>
                    </app-overview-card>
                </div>
            </div>
        </div>
    }

    <!-- enterprise user (i.e.: reseller) -->
    @if (user?.dashboard && isLoaded) {
        <div>
            <div class="dashboard-overview" [@staggerAnimation]>
                @if (isLoaded) {
                    <div [style.grid-area]="'side01'">
                        <app-overview-card [type]="5" title="{{'general.networkState' | transloco}}">
                            <app-server-avg class="svrChart" fxFlex="1 1 100%"></app-server-avg>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side02'">
                        <app-overview-card [type]="5" title="{{'general.studioActivity' | transloco}}">
                            <app-usage-avg class="svrChart" fxFlex="1 1 100%"></app-usage-avg>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side07'">
                        <app-overview-card [type]="5" title="{{'general.networkCPU' | transloco}}1">
                            <app-overview-network-cpu [header]="'general.globalCPU' | transloco" [serverName]="'ALL'"
                                                      [enterpriseMode]="true"></app-overview-network-cpu>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side08'">
                        <app-overview-card [type]="5" title="{{'general.networkCPU' | transloco}}2">
                            <app-overview-network-cpu [header]="'general.routerNet' | transloco" [serverName]="'galaxy'"
                                                      [enterpriseMode]="true"></app-overview-network-cpu>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side09'">
                        <app-overview-card [type]="5" title="{{'general.liveLog' | transloco}}">
                            <app-overview-log [enterpriseMode]="true"></app-overview-log>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side10'">
                        <app-overview-card [type]="5" title="{{'general.networkCPU' | transloco}}3">
                            <app-overview-network-cpu [header]="'general.adnetInstance' | transloco" [serverName]="'adnet'"
                                                      [enterpriseMode]="true"></app-overview-network-cpu>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side11'">
                        <app-overview-card [type]="5" title="{{'general.playerSlider' | transloco}}">
                            <app-station-slider [stations]="stations"></app-station-slider>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side12'">
                        <app-overview-card [type]="5" title="{{'general.networkUsage' | transloco}}">
                            <app-network-instances></app-network-instances>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side13'">
                        <app-overview-card [type]="5" title="{{'general.enterpriseStatus' | transloco}}">
                            <ul class="globalStyle">
                                <br/>
                                <li>reseller id: {{ user.resellerId }}</li>
                                <li>business id: {{ user.businessId }}</li>
                                <li>payer id: {{ user.payerId }}</li>
                                <li>account status: {{ user.accountStatus }}</li>
                                <li>access: {{ isAccessDenied(this.user) === false ? 'enabled' : 'disabled' }}</li>
                                <li>{{ 'general.connection' | transloco }}: {{ user.mediaCloud }}</li>
                                <li>{{ 'general.user' | transloco }}: {{ user.username }}</li>
                                <li>{{ 'general.branding' | transloco }}: {{ user.statusLabel }}</li>
                                <li>{{ 'general.playerOn' | transloco }}: {{ screens.screenOn }}</li>
                                <li>{{ 'general.playerGeo' | transloco }}: {{ screens.geoScreens }}</li>
                                <li>{{ 'general.playerPolling' | transloco }}: {{ screens.screenPoll }}</li>
                                <li>{{ 'general.playerOff' | transloco }}: {{ screens.screenOff }}</li>
                                <li>{{ 'general.playerTotal' | transloco }}: {{ usage.stationsTotal }}</li>
                                <li>{{ 'general.playerCapability' | transloco }}: ALL</li>
                                <li>{{ 'general.playerSockets' | transloco }}: 80/443</li>
                                <li>{{ 'general.businesses' | transloco }}: {{ business.totalBusinesses }}</li>
                                <li>{{ 'general.users' | transloco }}: {{ business.totalUsers }}</li>
                                <li>{{ 'general.apps' | transloco }}: {{ business.apps }}</li>
                                <li>{{ 'general.installedApps' | transloco }}: {{ business.installedApps }}</li>
                                <li>{{ 'general.privileges' | transloco }}: {{ business.priveleges }}</li>
                                <li>{{ 'general.name' | transloco }}: {{ contact?.firstName }}</li>
                                <li>{{ 'general.lastName' | transloco }}: {{ contact?.lastName }}</li>
                                <li>{{ 'general.phone' | transloco }}: {{ contact?.cellPhone }}</li>
                                <li>{{ 'general.work' | transloco }}: {{ contact?.workPhone }}</li>
                                <li>{{ 'general.location' | transloco }}: {{ contact?.city }} {{ contact?.state }}</li>
                            </ul>
                        </app-overview-card>
                    </div>
                }
                @if (isLoaded) {
                    <div [style.grid-area]="'side14'">
                        <app-overview-card [type]="5" title="{{'general.businessDistribution' | transloco}}">
                            <ngx-charts-bar-horizontal
                                    [scheme]="colorScheme"
                                    [showXAxisLabel]="true"
                                    [showYAxisLabel]="false"
                                    [xAxis]="true"
                                    [yAxis]="true"
                                    [legend]="false"
                                    [barPadding]="36"
                                    [showDataLabel]="true"
                                    [roundEdges]="false"
                                    [results]="dataBusiness"
                                    (select)="onSelect($event)">
                            </ngx-charts-bar-horizontal>
                        </app-overview-card>
                    </div>
                }
            </div>
        </div>
    }
</div>